<form class="admin-filters" nz-form [formGroup]="searchForm" (ngSubmit)="submitFilterForm()">
  <div class="admin-filters__fields">
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            formControlName="searchTerm"
            nz-input
            [placeholder]="'admin.filter.search.placeholder' | translate"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span *ngIf="!searchForm.get('searchTerm')?.value" nz-icon nzType="search"></span>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchForm.get('searchTerm')?.value"
            (click)="searchForm.get('searchTerm')?.setValue(null)"
          ></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-select
          nzAllowClear
          [nzPlaceHolder]="'admin.filter.status.reviewed.placeholder' | translate"
          formControlName="statusReviewed"
        >
          <nz-option [nzLabel]="'admin.filter.status.reviewed' | translate" [nzValue]="'REVIEWED'"></nz-option>
          <nz-option [nzLabel]="'admin.filter.status.not-reviewed' | translate" [nzValue]="'NOT_REVIEWED'"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-range-picker class="admin-filters__field" formControlName="timeRange"></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div class="admin-filters__actions">
    <nz-form-item>
      <nz-form-control>
        <button
          nz-button
          nzBlock
          nzType="default"
          type="button"
          [disabled]="isApiLoading"
          (click)="downloadMissionPartnerListCSV()"
        >
          <span nz-icon [nzType]="isApiLoading ? 'loading' : 'download'" nzTheme="outline"></span>
          {{ "admin.download.csv" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" [disabled]="!searchForm.valid">
          {{ "admin.filter.submit" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only" *ngIf="(isMobileLayout$ | async) === false">
<nz-table
  class="sticky-table" [nzScroll]="{ x: '1200px' }"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th nzColumnKey="COMPANY_NAME" [nzSortFn]="true">{{ "admin.company-name.title" | translate }}</th>
      <th nzColumnKey="STAGE">{{ "admin.stage.title" | translate }}</th>
      <th nzColumnKey="CONTACT_NAME" [nzSortFn]="true">{{ "admin.contact-name.title" | translate }}</th>
      <th nzColumnKey="EMAIL" [nzSortFn]="true">{{ "admin.email.title" | translate }}</th>
      <th nzColumnKey="STATUS" [nzSortFn]="true">{{ "admin.status.title" | translate }}</th>
      <th nzColumnKey="REG_TIMESTAMP" [nzSortFn]="true" nzSortOrder="descend">
        {{ "admin.registered.title" | translate }}
      </th>
      <th>{{ "admin.action.title" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>
        <a [routerLink]="['/admin/mission-partner-view', data.accountId.internalId]" target="_blank">
          {{ data.companyName }}
        </a>
      </td>
      <td>
        <nz-select
          nzShowSearch
          [nzOptions]="(stageOptions$ | async) || []"
          [nzPlaceHolder]="'admin.stage.placeholder' | translate"
          [ngModel]="data.stage"
          (ngModelChange)="setStageMissionPartner(data.accountId.internalId, $event)"
          style="width: 100%"
        ></nz-select>
      </td>
      <td>{{ data.contactName }}</td>
      <td>{{ data.email }}</td>
      <td>
        <span *ngFor="let s of data.statuses" [attr.data-tooltip]="s.toString()">
          {{ getStatusShortName(s) }}
        </span>
      </td>
      <td>{{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</td>
      <td class="nowrap">
        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.sign-in-as.tooltip' | translate"
          (click)="onSignInAs(data.accountId.internalId)"
        >
          <span nz-icon nzType="login" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="data.accountId.internalId"
          (click)="copyId(data.accountId.internalId)"
        >
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && !data.statuses.includes(AccountStatus.PASSIVE)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.set-passive-status.tooltip' | translate"
          (click)="setPassiveStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="eye-invisible" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && data.statuses.includes(AccountStatus.PASSIVE)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.remove-passive-status.tooltip' | translate"
          (click)="removePassiveStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="eye-invisible" nzTheme="fill"></span>
        </button>

        <button
          *ngIf="canWrite && !data.statuses.includes(AccountStatus.REVIEWED)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.review-mission-partner.tooltip' | translate"
          (click)="reviewMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="check-circle" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && data.statuses.includes(AccountStatus.REVIEWED)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.discard-review-mission-partner.tooltip' | translate"
          (click)="discardReviewMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="check-circle" nzTheme="fill"></span>
        </button>

        <button
          *ngIf="canWrite && !data.statuses.includes(AccountStatus.SELF_SERVICE)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.set-self-service-status.tooltip' | translate"
          (click)="setSelfServiceStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="tool" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && data.statuses.includes(AccountStatus.SELF_SERVICE)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.remove-self-service-status.tooltip' | translate"
          (click)="removeSelfServiceStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="tool" nzTheme="fill"></span>
        </button>

        <button
          *ngIf="canWrite && !data.statuses.includes(AccountStatus.PREMIUM)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.set-premium-status.tooltip' | translate"
          (click)="setPremiumStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="star" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && data.statuses.includes(AccountStatus.PREMIUM)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.remove-premium-status.tooltip' | translate"
          (click)="removePremiumStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="star" nzTheme="fill"></span>
        </button>

        <button
          *ngIf="canWrite && appConfig.featureStatus.jobOpportunityPublishing && !data.statuses.includes(AccountStatus.PUBLISHER)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.set-publisher-status.tooltip' | translate"
          (click)="setPublisherStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="file-text" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite && appConfig.featureStatus.jobOpportunityPublishing && data.statuses.includes(AccountStatus.PUBLISHER)"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.remove-publisher-status.tooltip' | translate"
          (click)="removePublisherStatusMissionPartner(data.accountId.internalId)"
        >
          <span nz-icon nzType="file-text" nzTheme="fill"></span>
        </button>

        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.confirmed-status.tooltip' | translate"
          (click)="setConfirmedStatus(data)"
        >
          <span
            nz-icon
            nzType="mail"
            [nzTheme]="data.statuses.includes(AccountStatus.CONFIRMED) ? 'fill' : 'outline'"
          ></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.password-reset-email.tooltip' | translate"
          (click)="sendPasswordResetEmail(data.accountId, data.email)"
        >
          <span nz-icon nzType="send" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.set-password.tooltip' | translate"
          (click)="openSetPasswordModal(data)"
        >
          <span nz-icon nzType="lock" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.comment.tooltip' | translate"
          (click)="openCommentModal(data)"
        >
          <span
            nz-icon
            nzType="message"
            [nzTheme]="data.commentsExist ? 'fill' : 'outline'"
            [class.comment-icon--active]="data.commentsExist"
          ></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.export-data.tooltip' | translate"
          (click)="downloadData(data.accountId)"
        >
          <span nz-icon nzType="database" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="canWrite"
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.delete-account.tooltip' | translate"
          (click)="showDeleteConfirm(data)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [attr.data-tooltip]="'admin.export-talent-to-brevo.label' | translate"
          (click)="exportMissionPartnerToBrevo(data)"
        >
          <span nz-icon nzType="export" nzTheme="outline"></span>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" *ngIf="isMobileLayout$ | async" style="margin-top: 16px;">
  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-bottom: 16px; text-align: center;"
  ></nz-pagination>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []" nzHoverable nzSize="small">
        <nz-row [nzGutter]="[0, 8]">
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.company-name.title" | translate }}:</strong>
            <div>
              <a [routerLink]="['/admin/mission-partner-view', data.accountId.internalId]" target="_blank">
                {{ data.companyName }}
              </a>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.stage.title" | translate }}:</strong>
            <div>
              <nz-select
                nzShowSearch
                [nzOptions]="(stageOptions$ | async) || []"
                [nzPlaceHolder]="'admin.stage.placeholder' | translate"
                [ngModel]="data.stage"
                (ngModelChange)="setStageMissionPartner(data.accountId.internalId, $event)"
                style="width: 100%"
              ></nz-select>
            </div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.contact-name.title" | translate }}:</strong>
            <div>{{ data.contactName }}</div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.email.title" | translate }}:</strong>
            <div style="word-break: break-all;">{{ data.email }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.status.title" | translate }}:</strong>
            <div>
              <span *ngFor="let s of data.statuses" [attr.data-tooltip]="s.toString()" style="margin-right: 4px;">
                {{ getStatusShortName(s) }}
              </span>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.registered.title" | translate }}:</strong>
            <div>{{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <strong>{{ "admin.action.title" | translate }}:</strong>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px;">
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.sign-in-as.tooltip' | translate" (click)="onSignInAs(data.accountId.internalId)">
                <span nz-icon nzType="login" nzTheme="outline"></span>
                {{ "admin.sign-in-as.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="data.accountId.internalId" (click)="copyId(data.accountId.internalId)">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                Copy ID
              </button>
              <button *ngIf="canWrite && !data.statuses.includes(AccountStatus.PASSIVE)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.set-passive-status.tooltip' | translate" (click)="setPassiveStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="eye-invisible" nzTheme="outline"></span>
                {{ "admin.set-passive-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && data.statuses.includes(AccountStatus.PASSIVE)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.remove-passive-status.tooltip' | translate" (click)="removePassiveStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="eye-invisible" nzTheme="fill"></span>
                {{ "admin.remove-passive-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && !data.statuses.includes(AccountStatus.REVIEWED)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.review-mission-partner.tooltip' | translate" (click)="reviewMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                {{ "admin.review-mission-partner.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && data.statuses.includes(AccountStatus.REVIEWED)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.discard-review-mission-partner.tooltip' | translate" (click)="discardReviewMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="check-circle" nzTheme="fill"></span>
                {{ "admin.discard-review-mission-partner.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && !data.statuses.includes(AccountStatus.SELF_SERVICE)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.set-self-service-status.tooltip' | translate" (click)="setSelfServiceStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="tool" nzTheme="outline"></span>
                {{ "admin.set-self-service-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && data.statuses.includes(AccountStatus.SELF_SERVICE)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.remove-self-service-status.tooltip' | translate" (click)="removeSelfServiceStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="tool" nzTheme="fill"></span>
                {{ "admin.remove-self-service-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && !data.statuses.includes(AccountStatus.PREMIUM)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.set-premium-status.tooltip' | translate" (click)="setPremiumStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="star" nzTheme="outline"></span>
                {{ "admin.set-premium-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && data.statuses.includes(AccountStatus.PREMIUM)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.remove-premium-status.tooltip' | translate" (click)="removePremiumStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="star" nzTheme="fill"></span>
                {{ "admin.remove-premium-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && appConfig.featureStatus.jobOpportunityPublishing && !data.statuses.includes(AccountStatus.PUBLISHER)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.set-publisher-status.tooltip' | translate" (click)="setPublisherStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="file-text" nzTheme="outline"></span>
                {{ "admin.set-publisher-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite && appConfig.featureStatus.jobOpportunityPublishing && data.statuses.includes(AccountStatus.PUBLISHER)" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.remove-publisher-status.tooltip' | translate" (click)="removePublisherStatusMissionPartner(data.accountId.internalId)">
                <span nz-icon nzType="file-text" nzTheme="fill"></span>
                {{ "admin.remove-publisher-status.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.confirmed-status.tooltip' | translate" (click)="setConfirmedStatus(data)">
                <span nz-icon nzType="mail" [nzTheme]="data.statuses.includes(AccountStatus.CONFIRMED) ? 'fill' : 'outline'"></span>
                {{ "admin.confirmed-status.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.password-reset-email.tooltip' | translate" (click)="sendPasswordResetEmail(data.accountId, data.email)">
                <span nz-icon nzType="send" nzTheme="outline"></span>
                {{ "admin.password-reset-email.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.set-password.tooltip' | translate" (click)="openSetPasswordModal(data)">
                <span nz-icon nzType="lock" nzTheme="outline"></span>
                {{ "admin.set-password.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.comment.tooltip' | translate" (click)="openCommentModal(data)">
                <span nz-icon nzType="message" [nzTheme]="data.commentsExist ? 'fill' : 'outline'" [class.comment-icon--active]="data.commentsExist"></span>
                {{ "admin.comment.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.export-data.tooltip' | translate" (click)="downloadData(data.accountId)">
                <span nz-icon nzType="database" nzTheme="outline"></span>
                {{ "admin.export-data.tooltip" | translate }}
              </button>
              <button *ngIf="canWrite" nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.delete-account.tooltip' | translate" (click)="showDeleteConfirm(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "admin.delete-account.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" [attr.data-tooltip]="'admin.export-talent-to-brevo.label' | translate" (click)="exportMissionPartnerToBrevo(data)">
                <span nz-icon nzType="export" nzTheme="outline"></span>
                {{ "admin.export-talent-to-brevo.label" | translate }}
              </button>
            </div>
          </nz-col>
        </nz-row>
      </nz-card>
    </div>
  </nz-spin>

  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-top: 16px; text-align: center;"
  ></nz-pagination>
</div>
